<template>
  <button class="button" @click="$emit('click')">
    <span class="icon">
      <i class="fa fa-save"></i>
    </span>
    <span v-if="label">{{ label }}</span>
  </button>
</template>

<script>
export default {
  name: 'DraftButton',
  props: {
    label: String
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/forms/DraftButton.vue